import type { IconNode } from '../types';

/**
 * @name hat-hard
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgNi4zYy0zLjQuOS02IDQtNiA3Ljd2MiIgLz4KICA8cGF0aCBkPSJNMTAgMTBWNWMwLS42LjQtMSAxLTFoMmMuNiAwIDEgLjQgMSAxdjUiIC8+CiAgPHBhdGggZD0iTTIwIDE2di0yYzAtMy43LTIuNi02LjgtNi03LjciIC8+CiAgPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjQiIHg9IjIiIHk9IjE2IiByeD0iMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/hat-hard
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const hatHard: IconNode = [
  ['path', { d: 'M10 6.3c-3.4.9-6 4-6 7.7v2', key: 'ovcwmr' }],
  ['path', { d: 'M10 10V5c0-.6.4-1 1-1h2c.6 0 1 .4 1 1v5', key: '5kswxs' }],
  ['path', { d: 'M20 16v-2c0-3.7-2.6-6.8-6-7.7', key: '2ot5i5' }],
  ['rect', { width: '20', height: '4', x: '2', y: '16', rx: '1', key: 'l35xhv' }],
];

export default hatHard;
